import React from 'react';
import { List, ListItem } from '@mui/material';

import { hasFreeSubscription, UpgradeNotification } from '@paragon/login-tools';

import { showUpgradeAccountDialog } from '../../../../../../store/actions/popupActions';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { MultiValueNumberInput } from '../../multi-value-controls/MultiValueNumberInput';
import { LoadSettingsControlProps } from '../LoadSettingsControls';

export function AtticRoomLoadSettings({
  disabled,
  loadSettingsArray,
  setLoadSettingsValues,
}: LoadSettingsControlProps) {
  const dispatch = useAppDispatch();

  // attic laods are not available to free users
  const isFreeUser = useAppSelector(hasFreeSubscription);
  if (isFreeUser) disabled = true;

  return (
    <List dense>
      <ListItem>
        {isFreeUser && (
          <UpgradeNotification
            sx={{ width: '100%', marginBottom: 1 }}
            briefDescription="attic loads"
            onUpgradeClick={() => dispatch(showUpgradeAccountDialog())}
          />
        )}
      </ListItem>

      <ListItem>
        <MultiValueNumberInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.atticFloorLiveLoad)}
          submit={(atticFloorLiveLoad) => setLoadSettingsValues({ atticFloorLiveLoad })}
          label="Floor Live Load"
          unit="psf"
          disabled={disabled}
        />
      </ListItem>
      <ListItem>
        <MultiValueNumberInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.atticFloorDeadLoad)}
          submit={(atticFloorDeadLoad) => setLoadSettingsValues({ atticFloorDeadLoad })}
          label="Floor Dead Load"
          unit="psf"
          disabled={disabled}
        />
      </ListItem>
      <ListItem>
        <MultiValueNumberInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.atticWallDeadLoad)}
          submit={(atticWallDeadLoad) => setLoadSettingsValues({ atticWallDeadLoad })}
          label="Wall Dead Load"
          unit="psf"
          disabled={disabled}
        />
      </ListItem>
      <ListItem>
        <MultiValueNumberInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.atticCeilingDeadLoad)}
          submit={(atticCeilingDeadLoad) => setLoadSettingsValues({ atticCeilingDeadLoad })}
          label="Ceiling Dead Load"
          unit="psf"
          disabled={disabled}
        />
      </ListItem>
    </List>
  );
}
